module.exports = __webpack_public_path__ + "static/media/icon-jishu.ef568cc9.svg";